import { render, staticRenderFns } from "./communityWechatList.vue?vue&type=template&id=bfa16310&scoped=true"
import script from "./communityWechatList.vue?vue&type=script&lang=js"
export * from "./communityWechatList.vue?vue&type=script&lang=js"
import style0 from "./communityWechatList.vue?vue&type=style&index=0&id=bfa16310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa16310",
  null
  
)

export default component.exports